/** 仓库管理API */
import type { Api } from '@/typings/api';
import { download, post } from '../../request';
const prefix = '/base/warehouse';
/**
 * 分页查询仓库管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.Warehouse> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询仓库管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.Warehouse> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个仓库管理
 *
 * @param id 仓库管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.Warehouse> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存仓库管理
 *
 * @param params 仓库管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新仓库管理信息
 *
 * @param params 仓库管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除仓库管理
 *
 * @param id 仓库管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除仓库管理
 *
 * @param ids 仓库管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params, 'XXXXX.xlsx');
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doExport
};
